module.exports = __webpack_public_path__ + "static/media/flower_video.6b31f15e.jpg";